import React from "react";
import styles from "./cp-data-table-action-bar.styles.css";

type CpDataTableActionBarProps = {
  className?: string;
  children?: React.ReactNode;
};

export function CpDataTableActionBar({
  className,
  children,
}: CpDataTableActionBarProps) {
  return (
    <div className={`${styles.actionBar} ${className || ""}`}>{children}</div>
  );
}
